import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { FormOfPaymentIssuerSearch } from "src/app/core/models/form-of-payment-model";
import { FormOfPaymentIssuerReferenceService } from "src/app/core/services/system-services/form-of-payment-issuer-reference.service";
import { FormOfPaymentIssuerSearchCriteria } from "./form-of-payment-issuer-search.model";
import { tap } from "rxjs/operators";
import { StatusReferenceModel } from "src/app/core/models/reference-model/reference-general-model";
import { StatusReferenceService } from "src/app/core/services/system-services";

@Injectable({
    providedIn: 'root'
})
export class FormOfPaymentIssuerSearchService {

    private _criteria$ = new BehaviorSubject<Map<string, FormOfPaymentIssuerSearchCriteria>>(new Map())
    private _formOfPaymentIssuers$ = new BehaviorSubject<FormOfPaymentIssuerSearch[]>([])
    private _statusReferenceModels$ = new BehaviorSubject<StatusReferenceModel[]>([])
    private _callSearch$ = new BehaviorSubject<boolean>(false)
    private _refresh$ = new Subject()

    get criteria$() {
        return this._criteria$.asObservable()
    }
    get formOfPaymentIssuers$() {
        return this._formOfPaymentIssuers$.asObservable()
    }
    get statusReferenceModels$() {
        return this._statusReferenceModels$.asObservable()
    }
    get callSearch$() {
        return this._callSearch$.asObservable()
    }
    get refresh$() {
        return this._refresh$.asObservable()
    }

    constructor(private formOfPaymentIssuerReferenceService: FormOfPaymentIssuerReferenceService,
        private statusReferenceService: StatusReferenceService) {
    }

    getFormOfPaymentIssuersSearch(criteria: FormOfPaymentIssuerSearchCriteria): Observable<FormOfPaymentIssuerSearch[]> {
        return this.formOfPaymentIssuerReferenceService.search(criteria.statusCode ?? '', criteria.formOfPaymentIssuerName ?? '', criteria.formOfPaymentIssuerCode ?? '')
            .pipe(
                tap(response => this._formOfPaymentIssuers$.next(response))
            )
    }

    updateStatusCode(formOfPaymentIssuerCode: string, statusCode: string): Observable<never> {
        return this.formOfPaymentIssuerReferenceService.updateStatusCode(formOfPaymentIssuerCode, statusCode)
    }

    loadStatusReference(): Observable<StatusReferenceModel[]> {
        return this.statusReferenceService.getAll().pipe(
            tap(response => this._statusReferenceModels$.next(response))
        )
    }

    clearSearch() {
        this._formOfPaymentIssuers$.next([])
    }
    callSearch() {
        this._callSearch$.next(true)
    }

    refresh() {
        this._refresh$.next()
    }

    saveCriteria(tabId: string, criteria: FormOfPaymentIssuerSearchCriteria) {
        const dataMap = this._criteria$.getValue()
        dataMap.set(tabId, { ...criteria })
        this._criteria$.next(dataMap)
    }

}